import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { UtilService } from '../../services/util.service';
import { Documento } from '../../models/Document';
import { ScnackbarData, ToastService, SnackbarStyles } from '../toast.service';
import { Router } from '@angular/router';
import { AccionTarea } from '../../models/Tarea';
import { AppTitleService } from '../../services/app-title.service';
import { AuthService } from '../../services/auth.service';
import { DocumentoService } from '../../services/documento.service';
import { TareaService } from '../../services/tarea.service';
import { DateService } from '../../shared/date.service';
import { Location } from '@angular/common';
import { TableSelectedDocumentsComponent } from "../table-selected-documents/table-selected-documents.component";

@Component({
    selector: 'app-restaurar',
    imports: [
        MatTableModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        ReactiveFormsModule,
        MatIconModule,
        MatProgressSpinnerModule,
        TableSelectedDocumentsComponent
    ],
    templateUrl: './restaurar.component.html',
    styleUrl: './restaurar.component.scss'
})
export class RestaurarComponent {
  taskData: number[];
  fetchingRestore = false;
  utilService = inject(UtilService)

  currentUserID: string
  documentsInformation: Documento[] = []

  restoreFormGroup = new FormGroup({
    comment: new FormControl("", {
      validators: [
        Validators.required,
        Validators.maxLength(255)
      ]
    })
  })

  snackbarData: ScnackbarData = {}

  constructor(
    private router: Router,
    private documentoService: DocumentoService,
    private tareaService: TareaService,
    private toast: ToastService,
    private authService: AuthService,
    private dateService: DateService,
    private location: Location
  ) {
    inject(AppTitleService).setTitle("Restaurar");

    const navigation = this.router.getCurrentNavigation();
    if (!navigation) {
      location.back()
    }
    this.taskData = navigation?.extras.state?.["documentIDs"]

    this.taskData.forEach((id) => {
      this.documentoService.getById(id).subscribe({
        next: (response) => {
          this.documentsInformation = [...this.documentsInformation, response]
        }
      })
    })
    this.currentUserID = this.authService.getTokenData()!.id;
  }

  ngOnInit(): void {
  }

  onCrearComentarioSubmit() {
    this.fetchingRestore = true
    let accionTareas: AccionTarea[] = []
    const comment = this.restoreFormGroup.controls.comment.value
    this.documentsInformation.forEach(document => {
      const accionTarea: AccionTarea = {
        id: document.idTarea,
        idParticipante: Number.parseInt(this.currentUserID),
        fechaExpira: this.dateService.formatDateToCustomString(new Date()),
        comentario: comment!
      }
      accionTareas.push(accionTarea)
    });

    this.tareaService.RestaurarDocumento(accionTareas).subscribe({
      next: (_) => {
        this.snackbarData.message = "Documento restaurado"
        this.snackbarData.style = SnackbarStyles.Success
        this.snackbarData.iconName = "check_circle"
        this.fetchingRestore = false
        this.toast.show(this.snackbarData)
        this.utilService.callTasks();
        this.location.back()
      },
      error: (_) => {
        this.snackbarData.message = "Error al restaurar documento"
        this.snackbarData.style = SnackbarStyles.Error
        this.snackbarData.iconName = "error"
        this.fetchingRestore = false
        this.toast.show(this.snackbarData)
      }
    })
  }


  formatDate(date: string): string {
    return this.dateService.formatCustomStringToDate(date)
  }

  selectAllText(event: FocusEvent) {
    const input = event.target as HTMLInputElement;
    input.select();
  }

  onCancel() {
    this.location.back()
  }

}
